module.exports = __webpack_public_path__ + "static/media/networking.ff8ae5ea.png";